/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Last_4_WeeksInputs */

const en_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 4 weeks`)
};

const de_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 4 Wochen`)
};

const es_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas 4 semanas`)
};

const fr_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 dernières semaines`)
};

const it_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime 4 settimane`)
};

const pt_br2_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas 4 semanas`)
};

const pl_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie 4 tygodnie`)
};

const hu_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbbi 4 hét`)
};

const ro_admin_dashboard_last_4_weeks = /** @type {(inputs: Admin_Dashboard_Last_4_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimele 4 saptamani`)
};

/**
* | output |
* | --- |
* | "Last 4 weeks" |
*
* @param {Admin_Dashboard_Last_4_WeeksInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_last_4_weeks = /** @type {((inputs?: Admin_Dashboard_Last_4_WeeksInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Last_4_WeeksInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_last_4_weeks(inputs)
	if (locale === "de") return de_admin_dashboard_last_4_weeks(inputs)
	if (locale === "es") return es_admin_dashboard_last_4_weeks(inputs)
	if (locale === "fr") return fr_admin_dashboard_last_4_weeks(inputs)
	if (locale === "it") return it_admin_dashboard_last_4_weeks(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_last_4_weeks(inputs)
	if (locale === "pl") return pl_admin_dashboard_last_4_weeks(inputs)
	if (locale === "hu") return hu_admin_dashboard_last_4_weeks(inputs)
	return ro_admin_dashboard_last_4_weeks(inputs)
});
export { admin_dashboard_last_4_weeks as "admin.dashboard.last_4_weeks" }